import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router';

import { getWorkspace } from '@mssgme/store';
import facebookImg from '@mssgme/app/img/facebook2.svg';
import telegramImg from '@mssgme/app/img/telegram2.svg';
import viberImg from '@mssgme/app/img/viber2.svg';
import vkImg from '@mssgme/app/img/vk.svg';
import MessengerIntegration from '../Vendors/MessengerIntegration';
import TelegramIntegration from '../Vendors/TelegramIntegration';
import ViberIntegration from '../Vendors/ViberIntegration';
import VKIntegration from '../Vendors/VKIntegration';

const routesMap = [
    {
        type: 'messenger',
        label: 'Messenger',
        logo: facebookImg,
        component: MessengerIntegration,
        tutorialSrc: {
            ru: 'https://www.youtube.com/embed/G0dcj6XLgAI?rel=0&modestbranding=1',
            en: 'https://www.youtube.com/embed/nQuFiYfktCw?rel=0&modestbranding=1',
        },
    },
    {
        type: 'telegram',
        label: 'Telegram',
        logo: telegramImg,
        component: TelegramIntegration,
        tutorialSrc: {
            ru: 'https://www.youtube.com/embed/oT7wfIUiaqg?rel=0&modestbranding=1',
            en: 'https://www.youtube.com/embed/qmDWl4Fz6Ps?rel=0&modestbranding=1',
        },
    },
    {
        type: 'viber',
        label: 'Viber',
        logo: viberImg,
        component: ViberIntegration,
        tutorialSrc: {
            ru: 'https://www.youtube.com/embed/kW28FFcrvVI?rel=0&modestbranding=1',
            en: 'https://www.youtube.com/embed/JOmI_Adg0h0?rel=0&modestbranding=1',
        },
    },
    {
        type: 'vk',
        label: 'VK',
        logo: vkImg,
        component: VKIntegration,
        tutorialSrc: {
            ru: 'https://www.youtube.com/embed/-SaCgQvvlxs?rel=0&modestbranding=1',
            en: 'https://www.youtube.com/embed/A-GYreJ6nR4?rel=0&modestbranding=1',
        },
    },
];

export const useIntegrationsPage = () => {
    const integrations = useSelector((state) => getWorkspace(state).integrations);
    const types = integrations.map((i) => i.type);
    const { t, i18n } = useTranslation();
    const match = useRouteMatch();
    const location = useLocation();
    const routes = routesMap.map((item) => ({
        ...item,
        path: `${match.path}/${item.type}`,
        integrated: types.includes(item.type),
        id: integrations.find((integration) => integration.type === item.type)
            ? integrations.find((integration) => integration.type === item.type)._id
            : null,
    }));
    const rootPath = location.pathname.startsWith('/i/onboard') ? '/i/onboard' : '/s/integrations';

    return {
        t,
        routes,
        rootPath,
        match,
        i18n,
    };
};
